import { Button } from '@bfe/moly';
import { Space } from 'antd';
// import classNames from 'classnames';
import { forwardRef, useImperativeHandle, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';

import { IPage, IPageAction } from '../SearchTablePage/utils/commonInterface';
interface IPaginationProps {
  defaultPageSize?: number;
  currentPage?: number;
  pageParams: IPage;
  onPreClick?: (args: IPageAction) => void;
  onNextClick?: (args: IPageAction) => void;
}

export interface IPaginationRef {
  resetPageNo: () => void;
  plusPageNo: () => void;
  minusPageNo: () => void;
}
// eslint-disable-next-line react/display-name
const Pagination = forwardRef<IPaginationRef, IPaginationProps>(
  (props, ref) => {
    const [$t] = useI18nContext();
    const [pageNo, setPageNo] = useState(1);
    const { lastPage } = props.pageParams;
    const leftClick = () => {
      props.onPreClick?.({
        action: 'prePage',
      });
    };

    const rightClick = () => {
      props.onNextClick?.({
        action: 'nextPage',
      });
    };

    const minusPageNo = () => {
      setPageNo(pageNo - 1);
    };

    const plusPageNo = () => {
      setPageNo(pageNo + 1);
    };
    useImperativeHandle(ref, () => ({
      resetPageNo: () => {
        setPageNo(1);
      },
      plusPageNo,
      minusPageNo,
    }));

    return (
      <div
        className="paginationContainer"
        style={{
          textAlign: 'right',
        }}
      >
        <Space size={8}>
          <Button
            variant="primary"
            size="x-small"
            disabled={pageNo === 1}
            onClick={leftClick}
          >
            {$t('Previous')}
          </Button>
          <Button
            variant="primary"
            size="x-small"
            onClick={rightClick}
            disabled={Number(lastPage) <= pageNo}
          >
            {$t('Next')}
          </Button>
        </Space>
      </div>
    );
  },
);
export default Pagination;
